export default __webpack_public_path__ + "static/media/report.75edc86b.png";